<template>
  <v-container fluid>
    <v-app-bar app>
      <v-btn icon to="/prealert">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title>{{language.pre_alerts}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon to="/prealert">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-app-bar>
    <div class="pt-4 pb-4 pl-4 pr-4">
      <v-card class="login-form">
        <v-card-text class="pb-0">
          <v-form v-model="valid">
            <h2 class="headline mb-3">{{language.create}} {{language.pre_alerts}}</h2>

            <v-text-field
              solo
              required
              :rules="required"
              v-model="text4"
              :label="language.tracking_no"
              type="text"
            ></v-text-field>
            <v-text-field
              solo
              required
              :rules="required"
              v-model="text5"
              :label="language.content"
              type="text"
            ></v-text-field>
            <v-text-field
              solo
              required
              :rules="required"
              v-model="text6"
              :label="language.invoice_value"
              type="text"
            ></v-text-field>
            <v-text-field
              solo
              required
              :rules="required"
              v-model="text7"
              :label="language.supplier"
              type="text"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="!valid" block color="primary" @click="validateLogin">{{language.save}}</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import Helpers from "../utils/helpers";
import language from '../utils/language';
import Server from "../utils/server";
export default {
  data() {
    return {
      clipped: false,
      currentUser: undefined,
      noData: false,
      loading: false,
      valid: false,
      required: [(v) => !!v || language.the_field_is_required],
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    login() {
      return this.$store.getters.login;
    },
    language: function () {
      return this.$store.getters.language;
    },
  },
  mounted() {
    console.log(Server);
    // if(this.currentUser != undefined){
    // }else

    if (this.user.userName != null) {
      this.currentUser = this.user;
    }
  },
  methods: {
    validateLogin: function () {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      formData.append("text4txt", this.text4);
      formData.append("text5txt", this.text5);
      formData.append("text6txt", this.text6);
      formData.append("text7txt", this.text7);

      console.log(Server.createPrealerta);
      // Helpers.getJson(Server.createPrealerta, "POST", formData, json => {});
      Helpers.getJson(Server.createPrealerta, "POST", formData, () => {});
      this.$router.push("prealert");
    },
  },
  name: "App",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
